const HomeAdmin = () => {
  return <></>;
};

export default HomeAdmin;
